
import { Injectable } from '@angular/core';
import HttpBase from '../models/httpBase';
import { Http, Response } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { WorkOrder, Report, SpecialInstruction, SubmitTask, Admission, ResearchInstruction } from '../models/index';
import EnvironmentService from '../services/environmentService';
import HttpError from '../models/httpError';

@Injectable()
export class ResearcherService extends HttpBase {
  private isSuccessful = false;

  constructor(http: Http, router: Router, private environmentService: EnvironmentService) {
    super(http, router);
  }
  // Get Task List
  getResearchTaskList(requestType: string, jurisdictionId: number): Observable<WorkOrder[]> {
    return this.httpGet(`${this.environmentService.taskListUrl}requestType=${requestType}&jurisdictionId=${jurisdictionId}`, false)
      .map((r: Response) => {
        if (r.status === 401 || r.status === 422) {
          this.router.navigate(['login']);
        } else {
          if (r.status === 200) {
            localStorage.setItem('jurisdictions', JSON.stringify((r.json()).jurisdictions));
            const wo = (r.json()).requests;
            return wo;
          }
        }
      });
  }
  // Submit Update
  submitTaskListData(submitTask: SubmitTask[]): Observable<number> {
    return this.httpPost(this.environmentService.getSubmitTasklUrl, submitTask, false)
      .map((r: Response) => {
        return r.status;
      });
  }
  // Mark Request Received
  markRequestReceived(requestNbr: any): Observable<void> {
    return this.httpPost(this.environmentService.markRequestReceivedUrl, requestNbr, false)
      .map((r: Response) => {
        if (r.status === 401) {
          window.close();
          this.router.navigate(['login']);
        } else {
          if (r.status === 200) {
            this.isSuccessful = r.status === 200;
          }
        }
      });
  }
  // Generate Work Order
  getWorkOrders(requestNbr: any): Observable<Report[]> {
    return this.httpPost(this.environmentService.GetWorkOrdersUrl, requestNbr, false)
      .map((r: Response) => {
        if (r.status === 401) {
          window.close();
          this.router.navigate(['login']);
        } else {
          if (r.status === 200) {
            const rpt = (r.json()).requests;
            return rpt;
          }
        }
      });
  }
  getSpecialInstructions(requestNbr: string): Observable<any> {
    return this.httpGet(`${this.environmentService.SpecialInstructionUrl}requestNbr=${requestNbr}`)
      .map((r: Response) => {
        if (r.status === 200) {
          return new SpecialInstruction(ResearchInstruction.getResearchInstruction(r.json().specialInstructions),
            r.json().specialInstructions.admissions === null ? null : Admission.getAdmissions(r.json().specialInstructions));
        } else if (r.status === 401) {
          window.close();
        }
        return new HttpError(r, this.environmentService.SpecialInstructionUrl);
      });
  }

  // Get Comments
  getResearchTaskComment(requestNbr: string): Observable<string> {
    return this.httpGet(`${this.environmentService.getResearchTaskCommentUrl}requestNbr=${requestNbr}`)
      .map((r: Response) => {
        if (r.status === 401) {
          window.close();
          this.router.navigate(['login']);
        } else {
          if (r.status === 200) {
            return (r.json().requestComments.comment);
          }
        }
      });
  }
  // Delete Comments
  deleteResearcherTaskComments(requestNbr: string): Observable<number> {
    return this.httpPost(this.environmentService.deleteResearchTaskCommentUrl, {
      RequestNbr: requestNbr
    }, true)
      .map((r: Response) => {
        if (r.status === 401) {
          window.close();
          this.router.navigate(['login']);
        }
        return r.status;
      });
  }
  // Save Comments
  saveResearcherTaskComments(requestNbr: string, comment: string): Observable<number> {
    return this.httpPost(this.environmentService.saveResearchTaskCommentUrl, {
      RequestNbr: requestNbr,
      Comment: comment
    }, true)
      .map((r: Response) => {
        if (r.status === 401) {
          window.close();
        }
        return r.status;
      });
  }
  get successful(): boolean {
    return this.isSuccessful;
  }
}





// WEBPACK FOOTER //
// ./src/services/researcherService.ts